
<template>
  <div class="help_page">
    <img class="help_header"
         v-if="topAdv.length>0"
         :src="topAdv[0].imgUrl"
         @click="toBannerClick(topAdv[0])"
         alt="">
    <div class="item"
         v-if="centreAdv.length>0">
      <div class="title_box noPadd">
        <h4 class="title"><span class="line_bl"></span>平台精选</h4>
      </div>
      <div class="item_img">
        <div class="fl first_img"
             @click="toBannerClick(centreAdv[0])">
          <img :src="centreAdv[0].imgUrl"
               alt=""></div>
        <div class="fl">
          <div class="second_img"
               @click="toBannerClick(centreAdv[1])"><img :src="centreAdv[1].imgUrl"
                 alt=""></div>
          <div class="third_img"
               @click="toBannerClick(centreAdv[2])"><img :src="centreAdv[2].imgUrl"
                 alt=""></div>
        </div>
      </div>
    </div>
    <div class="bg"
         v-if="HotNews.length>0"></div>
    <div class="item pd"
         v-if="HotNews.length>0">
      <div class="title_box">
        <h3 class="title"><span class="line_bl"></span>提额必看</h3>
        <p class="more"
           @click="toPage()">更多<span class="more_btn"></span></p>
      </div>
      <div v-for="(item,index) in HotNews"
           :key="index"
           @click="toArticleClick(item)">
        <div class="item_list"
             v-if="item.hasAdv">
          <img class="banner"
               :src="item.cover"
               alt="">
        </div>
        <div class="item_list"
             :class="{'noBorder':index==HotNews.length-1}"
             v-else>
          <div class="left">
            <h3 class="name"
                style="-webkit-box-orient: vertical;"><span class="isVip"
                    v-if="item.type.indexOf('2')!=-1"></span>{{item.title}}</h3>
            <p class="info"><span class="eyes"></span>{{item.peopleNum}}<span class="time">{{util.getTimer(item.time)}}</span></p>
          </div>
          <div class="right">
            <img :src="item.cover"
                 alt="">
          </div>
        </div>
      </div>
      <div class="shadow"
           v-if="isShowToast"></div>
      <div class="toast"
           v-if="isShowToast">
        <p class="toast_name">VIP专享权益</p>
        <span class="close_btn"
              @click="toPost"></span>
        <span class="toOpen"
              @click="toPost(1)">立即开通</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      isShowToast: 0,
      hasMember: 0,
      topAdv: [],
      centreAdv: [],
      HotNews: [],
    }
  },
  mounted () {
    this.util.title('提额助手');
    this.getArticleList();
    let json = {
      event_key: 'h5_assistant_view',
    }
    this.toCountPoint(json);
  },
  methods: {
    toPage () {
      window.location.href = "/information/hotInformation";
    },
    toBannerClick (item) {
      let json = {
        event_key: 'h5_assistant_ad_click'
      }
      this.toCountPoint(json);
      window.location.href = item.pageUrl;
    },
    toArticleClick (item) {
      let json = {
        event_key: 'h5_assistant_article_click',
        vip_status: item.status,
        vip_article: item.hasMember,
        article_id: item.id
      }
      this.toCountPoint(json);
      this.hasMember = item.hasMember;
      if (this.hasMember == true || item.type.indexOf('2') == -1) {//是会员 或者 不是会员专属文章
        window.location.href = "/information/informationDetail?id=" + item.id;
      } else {
        this.isShowToast = 1
      }
    },
    toPost (val) {
      this.isShowToast = 0;
      if (val == 1) {
        window.location.href = "/vip/handleVip";
      }
    },
    //统计埋点
    toCountPoint (json, pageUrl) {
      this.$get('/app/api/v1/newEventTrace', json)
        .then(res => {
          if (res.code == 200) {
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    getArticleList () {//
      let _this = this;
      let param = {
        type: 3
      }
      this.$get('/app/v1/news/getByTabNews', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.HotNews = e.data.HotNews;
            this.centreAdv = e.data.centreAdv;
            this.topAdv = e.data.topAdv;
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.help_page {
  width: 100%;
  background: #fff;
  padding-bottom: 0.3rem;
}
.pd {
  padding-bottom: 0.4rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.mgt {
  margin-top: 0.3rem;
}
.help_header {
  width: 100%;
  height: 2.2rem;
  /* background: url('../../assets/img/information/info_head.png') no-repeat center
    center; */
  /* background-size: 100% 100%; */
  /* background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  ); */
  /* padding: 0.25rem 0.15rem 0 0.15rem; */
}
.header_bg {
  height: 180px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(82, 82, 82, 0.15);
  border-radius: 10px;
  margin-bottom: 0.05rem;
}
.line_bl {
  display: inline-block;
  width: 3px;
  height: 12px;
  background: rgba(79, 140, 250, 1);
  margin-right: 0.06rem;
}
.title_box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  padding: 0 0.1rem;
  padding-top: 0.15rem;
}
.noPadd {
  padding-top: 0;
}
.title {
  font-size: 0.16rem;
  /* font-family: PingFangSC-Medium, PingFang SC; */
  /* font-weight: 500; */
  color: rgba(51, 51, 51, 1);
}
.more {
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.more_btn {
  margin-left: 0.07rem;
  display: inline-block;
  width: 0.12rem;
  height: 0.12rem;
  background: url('../../assets/img/information/right_btn.png') no-repeat center
    center;
  background-size: 100%;
  position: relative;
  top: 0.015rem;
}
.item_img {
  padding: 0.15rem;
  display: flex;
  justify-content: space-between;
}
.item_img .fl {
  flex: 1;
  margin-right: 0.08rem;
  border-radius: 4px;
}
.item_img div:last-child {
  margin-right: 0;
}
.first_img {
  height: 1.76rem;
}
.first_img img {
  width: 100%;
  height: 1.76rem;
  border-radius: 4px;
  display: block;
}
.second_img {
  margin-bottom: 0.08rem;
}
.third_img,
.second_img {
  border-radius: 4px;
  height: 0.84rem;
  display: block;
}
.third_img img,
.second_img img {
  width: 100%;
  height: 0.84rem;
  border-radius: 4px;
}
.item_list {
  display: flex;
  justify-content: space-between;
  padding: 0.12rem 0;
  margin: 0 0.15rem;
  border-bottom: 1px solid #f5f5f5;
}
.noBorder {
  border-bottom: 0;
}
.left {
  flex: 1;
  margin-right: 0.19rem;
}
.name {
  font-size: 0.14rem;
  /* font-family: PingFangSC-Medium, PingFang SC; */
  /* font-weight: 500; */
  color: rgba(51, 51, 51, 1);
  height: 46px;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}
.isVip {
  display: inline-block;
  width: 0.28rem;
  height: 0.14rem;
  border-radius: 2px;
  background: url('../../assets/img/information/vip_btn.png') no-repeat center
    center;
  background-size: 100%;
  position: relative;
  margin-right: 0.05rem;
  top: 0.015rem;
}
.info {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 0.1rem;
}
.time {
  float: right;
}
.eyes {
  display: inline-block;
  width: 0.11rem;
  height: 0.1rem;
  background: url('../../assets/img/information/eyes_btn.png') no-repeat top
    center;
  background-size: 100%;
  position: relative;
  top: 0.004rem;
  margin-right: 0.02rem;
}
.right {
  flex: 0 0 1.16rem;
  border-radius: 4px;
}
.right img {
  width: 100%;
  border-radius: 4px;
  height: 0.7rem;
  position: relative;
  top: 0.02rem;
  display: block;
}

/* 弹窗 */
.shadow {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 11;
  position: fixed;
  left: 0;
  top: 0;
}
.toast {
  position: absolute;
  left: 50%;
  top: 1.15rem;
  transform: translate(-50%, 0%);
  color: #fff;
  z-index: 111;
  width: 2.55rem;
  margin: 0 auto;
  background: url('../../assets/img/information/toast_bg.png') no-repeat center
    center;
  background-size: 100% 100%;
  height: 3.23rem;
  text-align: center;
  padding-top: 0.3rem;
  padding-bottom: 0.24rem;
}
.close_btn {
  background: url('../../assets/img/information/toast_close_btn.png') no-repeat
    center center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0.13rem;
  top: 0.17rem;
}
.toast_name {
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  letter-spacing: 2px;
  text-shadow: 0px 2px 4px rgba(0, 51, 150, 0.35);
}
.toOpen {
  display: inline-block;
  text-align: center;
  width: 2.25rem;
  height: 0.5rem;
  line-height: 50px;
  background: linear-gradient(
    180deg,
    rgba(250, 254, 255, 1) 0%,
    rgba(186, 223, 253, 1) 100%
  );
  box-shadow: 0px 2px 10px 0px rgba(0, 95, 210, 1);
  border-radius: 25px;
  font-size: 0.17rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(79, 140, 250, 1);
  position: absolute;
  bottom: 0.24rem;
  left: 0.15rem;
}
</style>

